import {
  ANDROID_WRAPPER_EVENTS,
  GAME_CLIENT_EVENTS,
  SESSION_EVENTS,
} from '@/event-manager/types';
import { useEventManagerRegister } from '@/event-manager/use-event-manager-register';
import { useClientCommunicationHandlers } from '@/game-client/hooks/use-client-communication-handlers';

const useClientCommunication = () => {
  const {
    gameReadyEventHandler,
    handshakeEventHandler,
    spinInProgressEventHandler,
    handleProviderError,
    toggleAudioEventHandler,
    gameLoadProgressEventHandler,
    requestGameWindowUiStateHandler,
    handleShowFunds,
    handleCloseGameLauncher,
    handleResetGame,
    handleResumeIncompleteGame,
    handleGameSwitch,
    handleRequestGameClose,
    handleContextParamMissing,
    contextReceivedEventHandler,
    handleDeviceOrientationInfo,
    handleRealityCheckModalEvent,
    handleModularDepositDismissed,
    handleSessionExtended,
  } = useClientCommunicationHandlers() ?? {};

  useEventManagerRegister([
    {
      type: GAME_CLIENT_EVENTS.INITIALIZE_CLIENT,
      handler: handshakeEventHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.GAME_READY,
      handler: gameReadyEventHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.GAME_LOAD_PROGRESS,
      handler: gameLoadProgressEventHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.SPIN_IN_PROGRESS,
      handler: spinInProgressEventHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.PROVIDER_ERROR,
      handler: handleProviderError,
    },
    {
      type: GAME_CLIENT_EVENTS.AUDIO_ENABLED,
      handler: toggleAudioEventHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.REQUEST_GAME_WINDOW_UI_STATE,
      handler: requestGameWindowUiStateHandler,
    },
    {
      type: GAME_CLIENT_EVENTS.SHOW_FUNDS,
      handler: handleShowFunds,
    },
    {
      type: GAME_CLIENT_EVENTS.CLOSE_GAME_LAUNCHER,
      handler: handleCloseGameLauncher,
    },
    {
      type: GAME_CLIENT_EVENTS.RESET_GAME,
      handler: handleResetGame,
    },
    {
      type: GAME_CLIENT_EVENTS.RESUME_INCOMPLETE_GAME,
      handler: handleResumeIncompleteGame,
    },
    {
      type: GAME_CLIENT_EVENTS.GAME_SWITCH,
      handler: handleGameSwitch,
    },
    {
      type: ANDROID_WRAPPER_EVENTS.REQUEST_GAME_CLOSE,
      handler: handleRequestGameClose,
    },
    {
      type: GAME_CLIENT_EVENTS.CONTEXT_PARAM_MISSING,
      handler: handleContextParamMissing,
    },
    {
      type: GAME_CLIENT_EVENTS.CONTEXT_RECEIVED,
      handler: contextReceivedEventHandler,
    },
    {
      type: ANDROID_WRAPPER_EVENTS.DEVICE_ORIENTATION_INFO,
      handler: handleDeviceOrientationInfo,
    },
    {
      type: ANDROID_WRAPPER_EVENTS.REALITY_CHECK_MODAL_EVENT,
      handler: handleRealityCheckModalEvent,
    },
    {
      type: ANDROID_WRAPPER_EVENTS.MODULAR_DEPOSIT_DISMISSED,
      handler: handleModularDepositDismissed,
    },
    {
      type: SESSION_EVENTS.TOKENS_UPDATE,
      handler: handleSessionExtended,
    },
  ]);
};

export default useClientCommunication;
